import { translate } from '@/utils/translations'

const buttonStyles = [
  'accordion__dialog-button',
  'link--branded',
  'styled-as-link',
  'u-weight--medium',
  'vst-btn--transparent'
].join(' ')

const DetailsButton = () => (
  <button className={buttonStyles}>
    {translate('promo_code.dialog.button')}
  </button>
)

export default DetailsButton
